<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-action-grid
    [data]="data"
    [loading]="loading"
    [rowSelection]="rowSelection"
    [columns]="columns"
    [exportExcelButton]="true"
  ></app-action-grid>
</app-main-contents>
